module.exports = __webpack_public_path__ + "static/media/AverilOfflineBookCover.936d2681.jpg";